import {
    GET_AI_SETTINGS_STARTED,
    GET_AI_SETTINGS_SUCCESS,
    GET_AI_SETTINGS_FAILURE,
    UPDATE_AI_GENERAL_SETTINGS_STARTED,
    UPDATE_AI_GENERAL_SETTINGS_SUCCESS,
    UPDATE_AI_GENERAL_SETTINGS_FAILURE,
    UPDATE_AI_RULE_SETTINGS_STARTED,
    UPDATE_AI_RULE_SETTINGS_SUCCESS,
    UPDATE_AI_RULE_SETTINGS_FAILURE,
    UPDATE_AI_HOURS_STARTED,
    UPDATE_AI_HOURS_SUCCESS,
    UPDATE_AI_HOURS_FAILURE,
    CANCEL_AI_RECEPTIONIST_STARTED,
    CANCEL_AI_RECEPTIONIST_SUCCESS,
    CANCEL_AI_RECEPTIONIST_FAILURE,
    REMOVE_ERROR_MESSAGE
} from '../../constants/ai-receptionist-settings/aiReceptionistSettings'


const initialState = {
    aiReceptionistSettings: null,
    loading: false,
    loadingRules: false,
    loadingHours: false,
    message: null,
    error: null
};

export default function aiReceptionistSettings(state = initialState, action) {
    switch (action.type) {
        case CANCEL_AI_RECEPTIONIST_STARTED: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        }
        case CANCEL_AI_RECEPTIONIST_SUCCESS: {
            localStorage.setItem("aiReceptionistEnabled", JSON.stringify({ aiReceptionistEnabled: false }));
            return {
                ...state,
                loading: false,
                aiReceptionistSettings: action.payload.data,
                error: null,
                message: "AI Receptionist has been cancelled successfully."
            };
        }
        case CANCEL_AI_RECEPTIONIST_FAILURE: {
            return {
                ...state,
                loading: false,
                aiReceptionistSettings: null,
                error: action.payload.error,
                message: null
            };
        }
        case GET_AI_SETTINGS_STARTED: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        }

        case GET_AI_SETTINGS_SUCCESS: {
            const aiSettings = action.payload.data;
            localStorage.setItem("aiReceptionistEnabled", JSON.stringify({ aiReceptionistEnabled: aiSettings ? aiSettings.aiReceptionistEnabled : false }));
            return {
                ...state,
                loading: false,
                aiReceptionistSettings: aiSettings,
                error: null,
            };
        }
        case GET_AI_SETTINGS_FAILURE: {
            return {
                ...state,
                loading: false,
                aiReceptionistSettings: null,
                error: action.payload.error,
                message: null
            };
        }
        case UPDATE_AI_GENERAL_SETTINGS_STARTED: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        }
        case UPDATE_AI_GENERAL_SETTINGS_SUCCESS: {
            return {
                ...state,
                loading: false,
                aiReceptionistSettings: action.payload.data,
                error: null,
                message: "AI Receptionist general settings updated successfully."
            };
        }
        case UPDATE_AI_GENERAL_SETTINGS_FAILURE: {
            return {
                ...state,
                loading: false,
                aiReceptionistSettings: null,
                error: action.payload.error,
                message: null
            };
        }
        case UPDATE_AI_RULE_SETTINGS_STARTED: {
            return {
                ...state,
                loadingRules: true,
                error: null,
                message: null
            };
        }
        case UPDATE_AI_RULE_SETTINGS_SUCCESS: {
            return {
                ...state,
                loadingRules: false,
                aiReceptionistSettings: action.payload.data,
                error: null,
                message: "AI Receptionist rules updated successfully."
            };
        }
        case UPDATE_AI_RULE_SETTINGS_FAILURE: {
            return {
                ...state,
                loadingRules: false,
                aiReceptionistSettings: null,
                error: action.payload.error,
                message: null
            };
        }

        case UPDATE_AI_HOURS_STARTED: {
            return {
                ...state,
                loadingHours: true,
                error: null,
                message: null
            };
        }

        case UPDATE_AI_HOURS_SUCCESS: {
            return {
                ...state,
                loadingHours: false,
                aiReceptionistSettings: action.payload.data,
                error: null,
                message: "AI Receptionist hours updated successfully."
            };
        }

        case UPDATE_AI_HOURS_FAILURE: {
            return {
                ...state,
                loadingHours: false,
                aiReceptionistSettings: null,
                error: action.payload.error,
                message: null
            };
        }

        case REMOVE_ERROR_MESSAGE: {
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };
        }

        default:
            return {
                ...state
            };
    }
}
